import React from "react";

import { Skeleton } from "@mui/material";

const ProfileHeaderLoader = () => {
  return (
    <div className={"profile-header"}>
      <div className="profile-header-content container">
        <div className="profile-avatar-info">
          <div className={"profile-avatar"}>
            <Skeleton
              variant="rectangular"
              style={{ height: 120, width: 120 }}
            />
          </div>
          <div className="profile-info">
            <div className="header-and-edit-button">
              <div className="header">
                <h1 className="profile-name profile-name-loading heading-3">
                  <Skeleton />
                </h1>
                <div className="location-website-parent location-website-parent-loading">
                  <Skeleton style={{ height: 18 }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeaderLoader;
